if (!customElements.get('ai3d-truth')) {
  class AI3DTruth extends HTMLElement {
    connectedCallback() {
      this.disconnect();

      this.abortController = new AbortController();
      this.signal = this.abortController.signal;
      this.cards = [...this.querySelectorAll('[data-truth-card]')];
      this.dialog = this.querySelector('[data-truth-dialog]');
      this.dialogImage = this.querySelector('[data-truth-dialog-image]');
      this.dialogTitle = this.querySelector('[data-truth-dialog-title]');
      this.dialogMeta = this.querySelector('[data-truth-dialog-meta]');
      this.dialogCounter = this.querySelector('[data-truth-dialog-counter]');
      this.dialogIndex = 0;

      this.querySelectorAll('[data-truth-lightbox-trigger]').forEach((button, index) => {
        button.addEventListener('click', () => this.openDialog(index), { signal: this.signal });
      });

      this.querySelector('[data-truth-dialog-close]')?.addEventListener(
        'click',
        () => this.dialog?.close(),
        { signal: this.signal }
      );

      this.querySelectorAll('[data-truth-dialog-step]').forEach((button) => {
        button.addEventListener(
          'click',
          () => this.showDialogImage(this.dialogIndex + Number(button.dataset.truthDialogStep)),
          { signal: this.signal }
        );
      });

      this.dialog?.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog) this.dialog.close();
        },
        { signal: this.signal }
      );

      this.dialog?.addEventListener('keydown', (event) => this.onDialogKeydown(event), {
        signal: this.signal
      });

      this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), {
        signal: this.signal
      });
    }

    disconnectedCallback() {
      this.disconnect();
    }

    disconnect() {
      this.abortController?.abort();
    }

    openDialog(index) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.showDialogImage(index);
      if (!this.dialog.open) this.dialog.showModal();
    }

    showDialogImage(index) {
      if (!this.dialogImage || this.cards.length === 0) return;

      this.dialogIndex = (index + this.cards.length) % this.cards.length;
      const trigger = this.cards[this.dialogIndex].querySelector('[data-truth-lightbox-trigger]');
      const sourceImage = trigger?.querySelector('img');

      this.dialogImage.src = trigger?.dataset.truthFullSrc || sourceImage?.currentSrc || sourceImage?.src || '';
      this.dialogImage.alt = sourceImage?.alt || trigger?.dataset.truthTitle || '';
      if (this.dialogTitle) this.dialogTitle.textContent = trigger?.dataset.truthTitle || '';
      if (this.dialogMeta) this.dialogMeta.textContent = trigger?.dataset.truthMeta || '';
      if (this.dialogCounter) {
        this.dialogCounter.textContent = `${this.dialogIndex + 1} / ${this.cards.length}`;
      }
    }

    onDialogKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      this.showDialogImage(this.dialogIndex + (event.key === 'ArrowRight' ? 1 : -1));
    }

    onBlockSelect(event) {
      const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
      if (index >= 0) this.cards[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  customElements.define('ai3d-truth', AI3DTruth);
}
